import React from 'react';
import './MattressGallery.css';

function MattressGallery() {
  return (
    <div className="gallery">
      <h2>Our Mattress Collection</h2>
      <div className="image-grid">
        <div className="image-item">
          <img src="mattress1.jpg" alt="Mattress 1" />
          <h3>Capri</h3>
        </div>
        <div className="image-item">
          <img src="mattress2.jpg" alt="Mattress 2" />
          <h3>Emperor</h3>
        </div>
        <div className="image-item">
          <img src="mattress3.jpg" alt="Mattress 3" />
          <h3>Deluxe</h3>
        </div>
        <div className="image-item">
          <img src="mattress4.jpg" alt="Mattress 4" />
          <h3>Crown</h3>
        </div>
        <div className="image-item">
          <img src="mattress5.jpg" alt="Mattress 5" />
          <h3>Italia</h3>
        </div>
        <div className="image-item">
          <img src="mattress6.jpg" alt="Mattress 6" />
          <h3>Regency</h3>
        </div>
      </div>
    </div>
  );
}

export default MattressGallery;
